import "./team.scss";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import p1 from "../../../Assets/images/team/aashma.png";
import p2 from "../../../Assets/images/team/sandip regmi.jpg";
import p3 from "../../../Assets/images/team/sagun kadel.jpg";
import p4 from "../../../Assets/images/team/radhesh shrestha.png";
import Partners from "../Partners/Partners";

const Team = () => {
  const teamMembers = [
    {
      name: "Aashma Bashyal",
      role: "President",
      img: p1,
      bio: "An MBA graduate, Aashma leads the organization with strategic insight and a focus on operational excellence.",
    },
    {
      name: "Sandip Regmi",
      role: "Managing Director",
      img: p2,
      bio: "A seasoned Geotechnical Engineer, Sandip ensures technical precision and project success from the ground up.",
    },
    {
      name: "Sagun Kandel",
      role: "Team Manager",
      img: p3,
      bio: "As a Structural Design Engineer, Sagun specializes in delivering efficient and innovative structural solutions.",
    },
    {
      name: "Radhesh Shrestha",
      role: "Team Manager",
      img: p4,
      bio: "With a background in Structural Design Engineering, Radhesh ensures safe and reliable design execution.",
    },
  ];

  return (
    <section className="team-section">
      <div class="testimonial-wave">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="320"
          height="104"
          viewBox="0 0 320 104"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 0H320C290.545 0 267.772 24.6753 253.628 49.8666C235.516 82.1247 200.378 104 160 104C119.622 104 84.4835 82.1247 66.3718 49.8666C52.228 24.6753 29.4552 0 0 0Z"
            fill="white"
          ></path>
        </svg>
      </div>
      <motion.div
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
        viewport={{ once: true }}
      >
        <h2>Meet The Team</h2>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: -100 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.99, ease: "easeOut", delay: 0.3 }}
        viewport={{ once: true }}
      >
        <p className="subdesc">
          We’re a diverse and growing community of tenacious problem-solvers,
          daring designers, creative coders, imaginative engineers, insightful
          economists, inventive acousticians, and experts in many other
          disciplines.
        </p>
      </motion.div>

      <div className="team-more">
        <Link to="/aboutpage#team" className="team-btn">
          See more
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            height="15px"
            width="15px"
            className="team-icon"
          >
            <path
              stroke-linejoin="round"
              stroke-linecap="round"
              stroke-miterlimit="10"
              stroke-width="1.5"
              stroke="#292D32"
              d="M8.91016 19.9201L15.4302 13.4001C16.2002 12.6301 16.2002 11.3701 15.4302 10.6001L8.91016 4.08008"
            ></path>
          </svg>
        </Link>
      </div>
      <div className="team-grid">
        {teamMembers.map((member, index) => (
          <div className="team-card" key={index}>
            <motion.div
              className="card-inner"
              initial={{ opacity: 0, y: 0, filter: "blur(10px)" }}
              whileInView={{
                opacity: 1,
                y: 0,
                filter: "blur(0px)",
                transition: { duration: 0.6, delay: index * 0.3 },
              }}
              viewport={{ once: true }}
            >
              <div className="image-container">
                <img src={member.img} alt={member.name} />
              </div>
              <div className="team-info">
                <h3>{member.name}</h3>
                <p className="role">{member.role}</p>
                <p className="bio">{member.bio}</p>
              </div>
            </motion.div>
          </div>
        ))}
      </div>
      <Partners />
    </section>
  );
};

export default Team;
